<template>
  <el-dialog
    :visible.sync="centerDialogVisible"
    :close-on-click-modal = 'false'
    :show-close ='false'
    center>
    <img src="@/assets/image/close.png" @click="centerDialogVisible = false"/>
    <h2>{{activeIndex == 1?'編輯房間':'新增房間'}}</h2>
    <p>{{activeIndex == 1?'':'單筆或批次新增房間，點選「＋」可往下新增。'}}    </p>
    <div class="roomBody">
       <div>
         <p><span>房號</span></p>
       </div>
      <div v-if="activeIndex != 1">
      <div v-for="(item,i) in roomList" :key="i">
         <el-input v-model="item.roomName"></el-input>
        <i v-if="i != roomList.length - 1" class="el-icon-minus" @click="del(i)"></i>
        <i v-else class="el-icon-plus" @click="add"></i>
      </div>
      </div>
      <div v-else>
        <el-input v-model="editobj.name"></el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
     <div @click="centerDialogVisible = false">取消填寫</div>
      <div @click="addroom">確認儲存</div>
  </span>
  </el-dialog>
</template>

<script>
import { addRoom, editRoom } from "@/api";

export default {
  name: "roomDig.vue",
  data(){
    return{
      centerDialogVisible: false,
      roomList:[
        {roomName: ''}
      ],
      activeIndex:0,
      editobj:{

      }
    }
  },
  methods:{
     init(i,row){
       if(i == 1){
         this.activeIndex = 1
         this.editobj = row
       }else{
         this.activeIndex = 0
         this.roomList =[
           {roomName: ''}
         ]
       }
        this.centerDialogVisible = true
     },
    add(){
        this.roomList.push({roomName: ''})
    },
    del(i){
       this.roomList.splice(i,1)
    },
    addroom(){
       if(this.activeIndex != 1) {
         const arr = []
         this.roomList.forEach(item => {
           arr.push(item.roomName)
         })
         addRoom({ data: arr }).then(res => {
           this.$emit('done')
           this.centerDialogVisible = false
         })
       }else{
         editRoom(this.editobj).then(res =>{
           this.$emit('done')
           this.centerDialogVisible = false
         })
       }
    }
  }
};
</script>



<style scoped lang="scss">
::v-deep .el-dialog{
  width: 650px;
  border-radius: 15px;
  padding: 0;
  position: relative;
}
img{
  width: 30px;
  height: 30px;
  object-fit: contain;
  position: absolute;
  right: -40px;
  top: 10px;
  cursor: pointer;
}
::v-deep .el-dialog__footer{
  padding: 0;
  .dialog-footer{
     display: flex;
    align-items: center;
    div{
      flex: 1;
      background: #DBBD80;
      color: #FFFFFF;
      font-size: 20px;
      padding: 15px 20px;
      cursor: pointer;
      font-weight: bolder;
    }
    div:first-child{
      border-radius: 0 0 0 15px;
      border-right: 1px solid #FFFFFF;
    }
    div:last-child{
      border-radius: 0 0 15px 0px;
    }
  }

}

h2{
  font-size: 30px;
  font-weight: bolder !important;
  text-align: center;
  margin: 0;
  color: #DBBD80;
  padding-bottom: 20px;
  border-bottom: 1px solid #DBBD80;
}
p{
  font-size: 20px;
  color: #b6b8bd;
  text-align: center;
}
.roomBody{
   div{
     display: flex;
     align-items: center;
     gap: 10px;
     margin-bottom: 10px;
     width: 100%;
     p{
       flex: 1;
       text-align: start;
       span{
         padding: 5px 30px;
         background: #F5F5F5;
         border-radius: 25px;
       }
     }
     i{
       padding: 10px;
       border-radius: 5px;
       border: 1px solid #DBBD80;
       color: #DBBD80;
       cursor: pointer;
     }
     ::v-deep .el-input__inner{
       border: none;
       border-bottom:1px solid  #DCDFE6;
       border-radius: 0;
     }
   }
}
</style>
